// @flow

import type {TransformOrigin, AnchorOrigin} from './typedef';


export const HorizontalPositionElement = {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT'
};

export const VerticalPositionElement = {
    TOP: 'TOP',
    CENTER: 'CENTER',
    BOTTOM: 'BOTTOM'
};

export const Types = {
    ABSOLUTE: 'ABSOLUTE',
    RELATIVE: 'RELATIVE'
};

export const INITIAL_FLIPPED = {
    height: false,
    width: false
};

export const TRANSFORM_ORIGIN: TransformOrigin = {
    vertical: VerticalPositionElement.TOP,
    horizontal: HorizontalPositionElement.LEFT
};

export const ANCHOR_ORIGIN: AnchorOrigin = {
    vertical: VerticalPositionElement.BOTTOM,
    horizontal: HorizontalPositionElement.LEFT
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
